import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectField from '../../../../core/components/Fields/SelectField.tsx';
import StringField from '../../../../core/components/Fields/StringField.tsx';
import FormField from '../../../../core/components/FormField.tsx';

const AgentDetailsFormFields = ({ form, teamOptions }) => {
    const { t } = useTranslation('assistants', { keyPrefix: 'agentConfig' });

    const formErrors = form.formState.errors;

    return (
        <div className="flex flex-col gap-4">
            <Controller
                name="name"
                control={form.control}
                rules={{ required: t('form.nameRequiredError') as string }}
                render={({ field }) => (
                    <FormField label={t('form.name')} required error={formErrors.name}>
                        <StringField required {...field} placeholder={t('form.namePlaceholder')} />
                    </FormField>
                )}
            />

            <Controller
                name="description"
                control={form.control}
                render={({ field }) => (
                    <FormField
                        label={t('form.description')}
                        error={formErrors.description}
                        helpText={t('form.descriptionHelpText')}
                    >
                        <StringField {...field} placeholder={t('form.descriptionPlaceholder')} />
                    </FormField>
                )}
            />

            <Controller
                name="teamId"
                control={form.control}
                render={({ field }) => (
                    <FormField
                        label={t('form.team')}
                        error={formErrors.teamId}
                        helpText={t('form.teamHelpText')}
                        required
                    >
                        <SelectField
                            {...field}
                            options={teamOptions}
                            renderOption={(option) => option.label}
                            required
                        />
                    </FormField>
                )}
            />
        </div>
    );
};

export default AgentDetailsFormFields;
